<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-11 mx-auto my-5 p-0">
        <div class="d-flex justify-content-between align-items-center pt-4">
          <Typography text="Administrar procesos" variant="h1" />
          <div class="d-flex align-items-center">
            <Button
              variant="primary"
              small
              label="Crear Proceso"
              showIcon
              icon="plus"
              @click="goCreate"
            />
            <File
              name="import-process"
              label="Importar"
              class="ml-4"
              @change="importData"
              accept=".xlsx, .xls"
            />
          </div>
        </div>
        <Typography
          text="Visualiza, gestiona y actualiza cada unos de los procesos registrados."
          variant="body"
        />
        <!-- Filter component -->
        <div class="my-5 col-12 p-0">
          <div
            :class="[
              'd-flex align-content-center',
              !isDisabled ? 'justify-content-end' : 'justify-content-between',
            ]"
          >
            <div class="d-flex">
              <Button
                variant="danger"
                small
                pill
                label="Limpiar filtros"
                v-show="isDisabled"
                @click.prevent="clearFilter"
                :disabled="isBusy"
              />
              <Button
                variant="primary"
                small
                pill
                class="ml-2"
                v-show="isDisabled"
                @click.prevent="onSubmitFilter"
                :disabled="isBusy"
              >
                <span class="mr-2">Aplicar filtros</span
                ><b-spinner v-if="isBusy" />
              </Button>
            </div>
            <div class="d-flex align-content-center">
              <button
                class="btn-dowland-csv"
                @click.prevent="exportReport"
                :disabled="isBusyExport"
              >
                <b-spinner v-if="isBusyExport" />
                Exportar CSV/XLS
                <svg
                  data-v-4fa86030=""
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19Z"
                    fill="#5d5fef"
                  ></path>
                </svg>
              </button>
              <Button
                v-b-toggle.accordion-1
                variant="secondary"
                pill
                class="ml-4"
              >
                <span class="when-opened">
                  Filtros
                  <img
                    class="centerImg1 pl-0"
                    src="@/assets/images/icons/filter.svg"
                  />
                </span>
              </Button>
            </div>
          </div>
          <div class="mt-5">
            <b-collapse
              id="accordion-1"
              class="filters p-4 position-relative"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div>
                <div class="row col-12 mx-0 px-0">
                  <div class="col-md-3">
                    <Typography
                      text="Fecha y Ciudad"
                      variant="CTA"
                      color="#5d5fef"
                      class="border-filters-title"
                    />
                    <div class="pt-2 space-y-4">
                      <Date
                        name="start_date"
                        label="Inicio"
                        v-model="valuesFilter.start_date"
                        :value="valuesFilter.start_date"
                        :max="valuesFilter.end_date"
                      />
                      <Date
                        name="end_date"
                        label="Fin"
                        v-model="valuesFilter.end_date"
                        :value="valuesFilter.end_date"
                        :min="valuesFilter.start_date"
                      />
                      <Select
                        label="Ciudad"
                        name="city"
                        :options="options.cities"
                        :value="valuesFilter.city_id"
                        v-model="valuesFilter.city_id"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 ml-8">
                    <Typography
                      text="Estado y Riesgo"
                      variant="CTA"
                      color="#5d5fef"
                      class="border-filters-title"
                    />
                    <div class="pt-2 space-y-4">
                      <Select
                        label="Estado"
                        name="status"
                        :options="options.status"
                        :value="valuesFilter.status"
                        v-model="valuesFilter.status"
                      />
                      <Select
                        label="Riesgo"
                        name="risk"
                        :options="options.risk_level"
                        :value="valuesFilter.risk"
                        v-model="valuesFilter.risk"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 ml-8">
                    <Typography
                      text="General"
                      variant="CTA"
                      color="#5d5fef"
                      class="border-filters-title"
                    />
                    <div class="pt-2">
                      <div class="row">
                        <div class="col-md-6 space-y-4">
                          <Input
                            label="Nro. Radicado"
                            name="file_number"
                            :value="valuesFilter.file_number"
                            @input="
                              (event) =>
                                (valuesFilter.file_number = event.target.value)
                            "
                          />
                          <Input
                            label="Demandante"
                            name="demandante"
                            :value="valuesFilter.demandante"
                            @input="
                              (event) =>
                                (valuesFilter.demandante = event.target.value)
                            "
                          />
                          <Select
                            label="Demandado"
                            name="defendants"
                            :options="options.defendants"
                            :value="valuesFilter.defendants"
                            v-model="valuesFilter.defendants"
                          />
                          <Select
                            label="Juzgado"
                            name="courts"
                            :options="options.courts"
                            :value="valuesFilter.court_id"
                            v-model="valuesFilter.court_id"
                          />
                        </div>
                        <div class="col-md-6 space-y-4">
                          <Select
                            label="Abogado"
                            name="lawyer"
                            :options="options.lawyers"
                            :value="valuesFilter.lawyer_id"
                            v-model="valuesFilter.lawyer_id"
                          />
                          <Select
                            label="Sindicato"
                            name="laborUnion"
                            :options="options.unions"
                            :value="valuesFilter.laborUnion"
                            v-model="valuesFilter.laborUnion"
                          />
                          <Select
                            label="Autoridad"
                            name="authority"
                            :options="plaintiffs"
                            :value="valuesFilter.plaintiff_name"
                            v-model="valuesFilter.plaintiff_name"
                          />
                          <Select
                            label="Objeto"
                            name="object"
                            :options="options.objects"
                            :value="valuesFilter.object_id"
                            v-model="valuesFilter.object_id"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="position-absolute img-filters">
                  <img class="h-100" src="@/assets/images/onboarding/filters_legal.svg" width="220" height="200"/>
                </div> -->
              </div>
            </b-collapse>
          </div>
        </div>
        <!-- Table component -->
        <div>
          <div class="mt-2 mb-1">
            <h3 class="mb-4">
              Registros encontrados: <strong>{{ datatable.total }}</strong>
            </h3>
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="table table-hover table-borderless"
              id="labor-table"
            >
              <template slot-scope="{ row, columns }">
                <tr>
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                      class="cell-border"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div class="col-12">
              <b-pagination
                class="justify-content-center pt-3"
                v-model="pagina"
                :total-rows="datatable.total"
                :per-page="datatable.per_page"
                aria-controls="my-table"
              ></b-pagination>
            </div>
            <div class="cont-no-data" v-show="datatable.rows.length <= 0">
              <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                <img
                  src="@/assets/images/demands/user-mail.svg"
                  alt="user email"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Modal Section-->
      <div>
        <b-modal id="modal-delete" centered hide-footer>
          <div class="text-center mb-4">
            <img
              src="@/assets/images/icons/warning_.svg"
              width="60px"
              height="60px"
              class="mx-auto"
            />
          </div>
          <Typography
            text="¡Eliminación de proceso!"
            variant="h2"
            class="text-center"
          />
          <Typography
            text="Está a punto de eliminar el proceso seleccionado, tenga en cuenta que esta acción NO se puede deshacer."
            variant="body"
            class="text-center"
          />
          <Typography
            text="¿Desea continuar con la eliminación del proceso?"
            variant="bodyBold"
            class="text-center"
          />
          <div class="row justify-content-center mt-4">
            <Button label="Continuar" variant="danger" @click="deleteProcess" />
            <Button
              label="Cancelar"
              variant="secondary"
              class="ml-4"
              @click="closeModal('modal-delete')"
            />
          </div>
        </b-modal>
      </div>
      <!-- Modal List Answer security -->
      <ModalListSecurityAnswer
        :isFirstTime="isFirstTime"
        @onSuccess="onSuccess"
        @onError="onError"
      />
      <ModalSuccess :messageModal="messageModal" />
      <ModalError :messageModal="messageModal" />
      <ModalBlocked />
      <ModalSecurityAnswer
        :isInactive="isInactive"
        @onSuccess="onSuccess"
        @onError="onError"
        @onBlocked="onBlocked"
      />
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { useView } = useProcess();

export default useView;
</script>

<style lang="scss" src="./Process.scss"></style>
